export default __webpack_public_path__ + "static/Torus_2-d3ef8e1237bab9335f7f5e19d0b01743.mp4";